import React from 'react';
import { useRouter } from 'next/router';

type GoogleMapsProps = {
  lat: number;
  long: number;
  zoom?: number;
};

// Keyless Google Maps embed (output=embed) instead of the JS API to avoid
// per-load billing. Requires no API key and no Cloud Console setup; renders
// the default marker with zoom/pan out of the box.
const GoogleMaps = (props: GoogleMapsProps) => {
  const { lat, long, zoom } = props;
  const { locale } = useRouter();

  const language = locale === 'ar' ? 'ar' : 'en';
  const src =
    'https://maps.google.com/maps' +
    `?q=${lat},${long}` +
    `&z=${zoom ?? 12}` +
    `&hl=${language}` +
    '&output=embed';

  return (
    <iframe
      title='Cinema location map'
      src={src}
      width='100%'
      height='100%'
      style={{ border: 0, borderRadius: '20px', display: 'block' }}
      loading='lazy'
      referrerPolicy='no-referrer-when-downgrade'
      allowFullScreen
    />
  );
};

export default GoogleMaps;
